/**
 * Back to top
 *
 * Smooth-scrolls to the top when the footer control is clicked; jumps instantly
 * under prefers-reduced-motion.
 */
export default class BackToTop {
    constructor() {
        const button = document.querySelector('.js-back-to-top');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            const reduceMotion = window.matchMedia(
                '(prefers-reduced-motion: reduce)'
            ).matches;

            window.scrollTo({
                top: 0,
                behavior: reduceMotion ? 'auto' : 'smooth',
            });
        });
    }
}
